import React, {useMemo} from 'react';
import {Box} from '@mui/material';
import L from 'leaflet';
import {MapContainer, Marker} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import {renderToStaticMarkup} from 'react-dom/server';
import AbribacIcon, {ABRIBAC, verdictDeCouleur} from '../AbribacIcon.js';
import CustomTileLayer from '../../../app/components/layout/map/CustomTileLayer.js';

const TAILLE_ABRIBAC = 40;

// Abribac (prototype CLI-02) : couleur = verdict courant, glyphe déduit de la couleur ; ancré au centre du socle.
function iconeMarqueur(couleur) {
    const html = renderToStaticMarkup(<AbribacIcon size={TAILLE_ABRIBAC} couleur={couleur} glyphe={verdictDeCouleur(couleur) || 'ni'}/>);
    return L.divIcon({
        className: '',
        iconSize: [TAILLE_ABRIBAC, TAILLE_ABRIBAC],
        iconAnchor: [TAILLE_ABRIBAC / 2, (TAILLE_ABRIBAC * ABRIBAC.ancreY) / 24],
        html,
    });
}

/**
 * Mini-carte du point (R4) : marqueur officiel seul, carte figée (aucune position terrain).
 * Sans coordonnées : cadre neutre, aucune position inventée.
 */
export default function FicheMiniCarte({lat, lng, couleur, hauteur = 170, etiquette}) {
    const icone = useMemo(() => iconeMarqueur(couleur), [couleur]);
    const position = lat != null && lng != null ? [lat, lng] : null;
    return (
        <Box role="img" aria-label={etiquette} sx={{position: 'relative', height: hauteur, bgcolor: '#E4E9E2', overflow: 'hidden', '& .leaflet-container': {height: '100%', width: '100%', fontFamily: 'inherit'}}}>
            {position ? (
                <MapContainer
                    center={position}
                    zoom={16}
                    zoomControl={false}
                    dragging={false}
                    scrollWheelZoom={false}
                    doubleClickZoom={false}
                    touchZoom={false}
                    keyboard={false}
                    boxZoom={false}
                >
                    <CustomTileLayer/>
                    <Marker position={position} icon={icone} interactive={false} keyboard={false}/>
                </MapContainer>
            ) : (
                <Box sx={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#8A929C', fontSize: 13}}>Position —</Box>
            )}
        </Box>
    );
}
